export namespace InvestigationConstant {
  export const IMAGE_FILE_EXT_LIST = ['png', 'jpg', 'jpeg'];
  export const DOCUMENT_FILE_EXT_LIST = ['pdf'];
}
